import { Component } from '@angular/core';

@Component({
  templateUrl: './sso-sign-in.component.html',
  styleUrls: ['./sso-sign-in.component.scss'],
  standalone: true,
})
export class SsoSignInComponent {}
